import React from 'react'
import CustomContainer from '../../components/common/CustomContainer'
import { useNavigate } from 'react-router-dom'
import styles from "../../assets/styles/labtest.module.css"
import MyPatientTable from '../../components/profile/MyPatientTable'

const MyPatient = () => {
    const navigate = useNavigate();

    return (
        <CustomContainer>
            <div className='AllPageMain'>
                <div className='HeadAndButton'>
                    <h2>My Patients</h2>
                </div>
                <div className={styles.labTestMain}>
                    <MyPatientTable />
                </div>
            </div>
        </CustomContainer>
    )
}

export default MyPatient